/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  ComponentType,
  ReactElement,
} from 'react';

import type {
  PreviousLinkProps,
} from '@vtaits/react-paginator';

import type {
  PaginatorPayload,
} from '../types';

import {
  StyledSideButton,
  StyledSideButtonLink,
} from './styled';

export function PreviousLink({
  Link,
  isDisabled,
  rootProps: {
    payload,
  },
  innerProps,
  children,
}: PreviousLinkProps<PaginatorPayload>): ReactElement | null {
  if (payload?.isOnePage) {
    return null;
  }

  return (
    <StyledSideButton>
      <StyledSideButtonLink
        as={Link as ComponentType<any>}
        {...innerProps}
        isDisabled={isDisabled}
      >
        {children}
      </StyledSideButtonLink>
    </StyledSideButton>
  );
}
